<template>
	<div id="login" class="container">
		<div class="deco-wireframe"></div>

		<div
			class="position-absolute top-50 start-50 translate-middle text-center"
		>
			<div class="mb-6">
				<img
					class="img-fluid logo"
					src="./../../assets/logo.svg"
					alt=""
				/>
			</div>

			<form>
				<div
					class="row col-10 col-md-8 col-lg-6 col-xl-4 m-auto text-start"
				>
					<div>
						<label
							for="exampleInputEmail1"
							class="form-label ff-ch fs-0"
							>登入信箱</label
						>
						<input
							type="email"
							class="form-control ff-ch fs-0"
							v-model="email"
						/>
						<!-- <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> -->
					</div>
					<div class="mt-3">
						<label for="password" class="form-label ff-ch fs-0"
							>密碼</label
						>
						<input
							type="password"
							class="form-control"
							v-model="password"
						/>
						<!-- <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> -->
					</div>
					<div class="pt-9 position-relative">
						<div id="g-recaptcha" class="m-auto"></div>
						<div
							@click="login_submit"
							class="btn btn-primary mt-4 py-custom w-100 ff-ch fw-light fs-0"
							>登入</div
						>
					</div>
				</div>
			</form>
		</div>
		<footer class="footer">
			<div class="row g-0 justify-content-between fs--1 mt-4 mb-3 ff-ch">
				<div class="col-12 col-sm-auto text-center">
					<p class="mb-0 text-600"
						>Thank you for joining the SMA PowerUp</p
					>
				</div>
				<div class="col-12 col-sm-auto text-center">
					<p class="mb-0 text-600 lh-base">
						2021
						<a href="">©Biogen</a> copy rights reserved
						<span class="d-none d-sm-inline">|</span
						><br class="d-sm-none" />
						Biogen-145353-TW-12/2021
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "./../../script/api";

export default {
	data() {
		return {
			email: "",
			password: "",
		};
	},

	mounted() {
		this.grecaptcha_init();
	},

	computed: {
		...mapGetters({ userData: "getUserData" }),
	},

	methods: {
		login_submit() {
			let gc = grecaptcha.getResponse();

			if (this.email === "" || this.password === "") {
				alert("請輸入帳號或密碼");
				return;
			} else if (gc.length == 0) {
				alert("請勾選我不是機器人");
				return;
			}

			let data = {
				email: this.email,
				password: this.password,
				"g-recaptcha-response": gc,
			};

			Api.post("api/user_login", data, async (res) => {
				if (res.res && res.msg == "ok") {
					const response = await this.$store.dispatch(
						"handleSetUserData",
						res.token
					);
					this.$store.dispatch("handleSetToken", res.token);

					if (response.survay === "N") {
						this.$router.push("/survey");
					} else {
						this.$router.push("/test/");
					}
				} else {
					grecaptcha.reset();
					alert(res.responseJSON.msg);
				}
			});
		},

		grecaptcha_init() {
			try {
				if (grecaptcha) {
					var elem = document.getElementById("g-recaptcha");
					grecaptcha.render(elem, {
						sitekey: "6Lf9aw4UAAAAAIJ5GJ-7s_bA6-H-02NxpG8eyHI0",
					});
				}
			} catch (e) {
				setTimeout(this.grecaptcha_init, 500);
			}
		},
	},
};
</script>

<style lang="scss">
#login.container {
	min-height: 100vh;

	> div {
		width: 100%;
	}
}

#g-recaptcha {
	position: absolute;
	display: inline-block;
	left: 50%;
	top: 20%;
	transform: translateX(-50%) scale(0.9);
}

.py-custom {
	padding-top: 0.75rem !important;
	padding-bottom: 0.75rem !important;
}
</style>
